import { ReactElement } from 'react'

import { TFunction } from 'i18next'
import { transparentize } from 'polished'
import { useTranslation } from 'react-i18next'

import { Flex, Text } from 'components/core'
import { colors } from 'styles/colors'
import { SovBadge } from 'types'

const getBadgeConfigs = (
    t: TFunction
): Record<SovBadge, { name: string; color: string }> => ({
    amazonChoice: {
        name: t('sov:badges.amazonChoice', "Amazon's Choice"),
        color: colors.colorAccentSteelBlue,
    },
    amazonExclusive: {
        name: t('sov:badges.amazonExclusive', 'Amazon Exclusive'),
        color: colors.colorAccentAmber,
    },
    bestSeller: {
        name: t('sov:badges.bestSeller', 'Best Seller'),
        color: colors.colorAccentOlive,
    },
    editorsPick: {
        name: t('sov:badges.editorsPick', "Editors' Pick"),
        color: colors.colorAccentPurple,
    },
    goodreadsChoice: {
        name: t('sov:badges.goodreadsChoice', 'Goodreads Choice'),
        color: colors.colorAccentTerracotta,
    },
    newArrivalPick: {
        name: t('sov:badges.newArrivalPick', 'New Arrival Pick'),
        color: colors.colorAccentCornflower,
    },
    overallPick: {
        name: t('sov:badges.overallPick', 'Overall Pick'),
        color: colors.colorAccentBrown,
    },
    prescriptionRequired: {
        name: t('sov:badges.prescriptionRequired', 'Prescription Required'),
        color: colors.colorAccentTeal,
    },
    teachersPick: {
        name: t('sov:badges.teachersPick', "Teachers' Pick"),
        color: colors.colorAccentBerry,
    },
})

interface SovBadgesJsonCellProps {
    badges: SovBadge[]
}

export const SovBadgesJsonCell = ({
    badges,
}: SovBadgesJsonCellProps): ReactElement => {
    const { t } = useTranslation()
    const badgeConfigs = getBadgeConfigs(t)

    return (
        <Flex gap={4} wrap="wrap">
            {badges.map((badge) => {
                const badgeConfig = badgeConfigs[badge]
                return (
                    <Flex
                        key={badge}
                        style={{
                            height: 20,
                            padding: '0 3px',
                            borderRadius: 12,
                            backgroundColor: transparentize(
                                0.8,
                                badgeConfig.color
                            ),
                        }}
                    >
                        <Text
                            variant="bodySm"
                            fontWeight={500}
                            padding="0 8px"
                            style={{ color: badgeConfig.color }}
                        >
                            {badgeConfig.name}
                        </Text>
                    </Flex>
                )
            })}
        </Flex>
    )
}
